import React, { useEffect, useState } from 'react';
import VideoCard from '../Components/VideoCard'
import { useLocation } from 'react-router-dom';
import Sidebar from '../Components/Sidebar';
import Header from '../Components/Header';
import BackButton from '../Components/BackButton';
import GlobalAlert from '../Components/GlobalAlert'


export default function Category() {

  const location = useLocation();
  const { category } = location.state || {}; // Handle undefined state


  console.log(category)
  const [data, setData] = useState([]);


  useEffect(() => {
    const sessiondata = JSON.parse(sessionStorage.getItem('av_data'))

    if (sessiondata) {
      setData(sessiondata)
    }


  }, []);


  return (
    <div>

      <Sidebar data={data} />
      <GlobalAlert/>
      <div className='main-body' >
        <div className='container' >
          <BackButton />
          <h2 className='my-4 spangreen bold' >{category.Name}</h2>
          <div className='videos-container' >
            
            {category.Content.map((video, index) => (
              <VideoCard key={index} video={video} category={category} /> // Pass 'video' correctly
            ))}

          </div>
        </div>

      </div>


    </div>
  )
}
